export default __webpack_public_path__ + "static/media/849.89608c35.png";